var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2928 10.293L12.6988 11.887C11.9598 11.667 10.5808 11.167 9.70685 10.293C8.83285 9.41901 8.33285 8.04001 8.11285 7.30101L9.70685 5.70701C10.0978 5.31601 10.0978 4.68401 9.70685 4.29301L5.70685 0.293006C5.31585 -0.0979941 4.68385 -0.0979941 4.29285 0.293006L1.58085 3.00501C1.20085 3.38501 0.986845 3.90701 0.994845 4.44001C1.01785 5.86401 1.39485 10.81 5.29285 14.708C9.19085 18.606 14.1368 18.982 15.5618 19.006C15.5668 19.006 15.5848 19.006 15.5898 19.006C16.1178 19.006 16.6168 18.798 16.9948 18.42L19.7068 15.708C20.0978 15.317 20.0978 14.685 19.7068 14.294L15.7068 10.293C15.3158 9.90201 14.6838 9.90201 14.2928 10.293ZM6.70685 13.293C3.34085 9.92701 3.01485 5.64201 2.99485 4.41901L4.99985 2.41401L7.58585 5.00001L6.29285 6.29301C6.05385 6.53101 5.95185 6.87501 6.02085 7.20501C6.04485 7.32001 6.63185 10.047 8.29185 11.707C9.95185 13.367 12.6788 13.954 12.7938 13.978C13.1268 14.049 13.4678 13.946 13.7058 13.707L14.9998 12.414L17.5858 15L15.5798 17.005C14.3318 16.984 10.0618 16.649 6.70685 13.293Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone2);
export default __webpack_public_path__ + "static/media/phone2.d4404034528e96b32c00921f3232582e.svg";
export { ForwardRef as ReactComponent };